import OrderFormPresenter from "../components/order-form/presenter/order-form";

const orderFormElement = document.querySelector(`.cart-order-form`);
const sectionCartTitleElement = document.querySelector(`.section_cart-title`);
const sectionPromocodeElement = document.querySelector(`.section_cart-promocode`);
const sectionCartOrderElement = document.querySelector(`.section_cart-order`);

if (orderFormElement) {
  const orderFormComponent = new OrderFormPresenter(
      orderFormElement,
      sectionCartTitleElement,
      sectionPromocodeElement,
      sectionCartOrderElement
  );
  orderFormComponent.init();
}

